
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Confirm from 'vux/src/components/confirm/index.vue'

import util from "@/javascript/util";
import goBack from '@/components/public-components/goBack/index.vue'

export default {
name: 'myOrder',
components: {
Tab,
TabItem,
Confirm,
goBack
},
data() {
return {
minHeight: 0,
tabIndex: 0,

tabData: [
{
name: '全部',
type: ''
},
{
name: '待支付',
type: [1]
},
{
name: '已支付',
type: [2,5,9,11]
},
{
name: '待评价', //订单完成后可评价
type: [4],
comment: true
},
{
name: '退款/退货',
type: [6,7,8,13]
}
],
orderList: [],
icon1: require('../../../../assets/lyx-img/order-1.png'),
icon2: require('../../../../assets/lyx-img/order-2.png'),
icon3: require('../../../../assets/lyx-img/order-3.png'),
pageNo: 0,
pageSize: 10,
infiniteStatus: false,
infiniteAll: false,

coverOpacity: false,
orderStatus: '',
cancelConfirm: false,
deleteConfirm: false,
confirmConfirm:false,
operateListIndex: -1,
value:'',
comment: ''
}
},
watch: {
'$route'(to, from) {

this.pageNo = 0
this.pageSize = 10
this.infiniteStatus = false
this.infiniteAll = false
this.$nextTick(function () {
this.getTabData()
})
}
},
mounted() {
const _this = this
document.title = "我的订单"
_this.minHeight = document.documentElement.clientHeight || document.body.clientHeight

_this.tabIndex = parseInt(_this.$route.query.status ? _this.$route.query.status : 0)
_this.orderStatus = _this.$route.query.status ? _this.tabData[parseInt(_this.$route.query.status)].type : ''
_this.comment = _this.$route.query.status ? _this.tabData[parseInt(_this.$route.query.status)].comment : ''

_this.getTabData()

window.addEventListener("scroll", this.windowScroll)
},
methods: {
clearValue: function () {
this.value = ''
},
goOneOrder(item) {
switch (item.orderType) {
case 1: // 门票
this.$router.push({path: '/ticketPlay/'+item.mainOrderId+'/'+ item.orderType + '/' + item.id})
break;
case 2://酒店
this.$router.push({path: '/hotelPlay/'+item.mainOrderId+'/'+ item.orderType + '/' + item.id})
break;
case 3:
break;
case 4: //文创
this.$router.push({path: '/orderStay/' +item.mainOrderId +'/'+ item.orderType + '/'+item.commoditys[0].orderId})
break;
}
},
onItemClick(item,index) {
/*const _this = this

_this.tabIndex = index
_this.pageNo = 0
_this.pageSize = 10
_this.infiniteStatus = false
_this.infiniteAll = false
_this.orderStatus = item.type
_this.orderList = []

_this.$nextTick(function () {
_this.getTabData()
})*/
if (index == this.$route.query.status) {
return
}
this.tabIndex = index
this.orderStatus = item.type
this.comment = item.comment
this.orderList = []
this.$router.replace('/myOrder?status=' + index)

},
getTabData() {
const _this = this
_this.publicWay(JSON.parse(localStorage.getItem('userInfo')).access_token)
},
publicWay(access_token) {
const _this = this
_this.$http.get('/api/wtcp-ecrm/comOrderClient/orderPage?access_token=' + access_token + '&page=' + _this.pageNo + '&size=' + _this.pageSize + (_this.orderStatus ? '&orderStatus=' + _this.orderStatus : '') + (_this.comment ? '&comment=0' : '')).then(res => {
const data = res.data.data ? res.data.data.content : []

data.forEach(item => {
item.btnShow = true
item.commoditys.forEach(itm => {
if (itm.commodityAttributes) {
itm.commodityAttributes = JSON.parse(itm.commodityAttributes)
}
})
})

if(_this.pageNo > 0){
_this.orderList = [..._this.orderList, ...data]
}else{
_this.orderList = data
}
if (data.length < _this.pageSize) {
_this.infiniteAll = true
}
_this.infiniteStatus = false
}).then(() => {






})
},

windowScroll: function () {
if (util.pullUpLoad()) {
this.infinite()
}
},
infinite: function () {
if (this.orderList.length === 0) {
return;
}
if (this.infiniteAll) {
return;
}
if (this.infiniteStatus) {
return;
}
this.infiniteStatus = true;
this.pageNo += 1;
this.getTabData()
},

deleteOrder(index) {
this.deleteConfirm = true
this.operateListIndex = index
},
deleteOK() {
const _this = this
_this.deleteOne(JSON.parse(localStorage.getItem('userInfo')).access_token)
},
deleteOne(access_token) {
this.$http.delete('/api/wtcp-ecrm/comOrderClient/deleteOrder?access_token=' + access_token + '&mainOrderId=' + this.orderList[this.operateListIndex].mainOrderId + '&orderId=' + this.orderList[this.operateListIndex].commoditys[0].orderId + '&orderType=' + this.orderList[this.operateListIndex].orderType).then(res => {
if (res.data.data) {
this.orderList.splice(this.operateListIndex, 1)
}
})
},

goPay(item) {
let goodsName = ''
if(item.commoditys.length > 1){
goodsName = item.commoditys[0].name + '等' +item.commoditys.length + '件商品'
}else{
goodsName = item.commoditys[0].name
}
const param = {
body: goodsName,
disCountsMoney: item.discountsAmount,
orderCode: item.mainOrderCode,
payMoney: item.total
}
localStorage.setItem('0buy', '0buy')
this.$router.push({path: '/methodPay', query: param})
},

cancelOrder(index) {
this.cancelConfirm = true
this.operateListIndex = index
},
cancelOK() {
const _this = this
_this.cancelOne(JSON.parse(localStorage.getItem('userInfo')).access_token)
},
cancelOne(access_token){
this.$http.get('/api/wtcp-ecrm/order/common/cancer?access_token=' + access_token + '&id=' + this.orderList[this.operateListIndex].mainOrderId ).then(res => {
if (res.data.data) {
this.orderList[this.operateListIndex].orderStatus = 3
this.orderList[this.operateListIndex].orderStatusName = '已取消'
}
})
},
onCancel() {},
materialFlowNew(item) {
this.$router.push('/materialFlow?mainOrderId=' + item.mainOrderId + '&orderId=' + item.id)
},

goConfirm(index){
this.confirmConfirm= true
this.operateListIndex = index
},
confirmOK(){
const _this = this
_this.stayIn(JSON.parse(localStorage.getItem('userInfo')).access_token)
},
stayIn(access_token){
const _this = this
let params={
"id": _this.orderList[this.operateListIndex].id,
"stayStaus": 0
}
_this.$http.post('/api/wtcp-ecrm/order/hotel/confirmStay?access_token=' + access_token, params).then((response) => {
if (response.data.status === 1) {
_this.orderList[this.operateListIndex].orderStatus = 4
_this.orderList[this.operateListIndex].orderStatusName = '已完结'
}
})
},
goEvaluation(item,index){
let moduleCode = ''
let name = ''
if(item.orderType === 1){
moduleCode = this.EVAL_TYPE_CODE.JQ
name = item.commoditys[index].supplierName
}else if(item.orderType === 2){
moduleCode = this.EVAL_TYPE_CODE.JD
name = item.commoditys[index].supplierName
}else if(item.orderType === 4){
moduleCode = this.EVAL_TYPE_CODE.WC
name = item.commoditys[index].name
}
this.$router.push(`/evaluation/${item.commoditys[index].relativeId}/94/${moduleCode}/${name}?orderId=${item.id}&commodityId=${item.commoditys[index].commodityId}`)
},

applyRefund(item,index){
switch (item.orderType) {
case 1:  // 门票
this.$router.push({path: '/refundProduct/' + item.mainOrderId + '/' + item.commoditys[0].orderId + '/1/1'})
break;
case 2:  // 酒店
this.$router.push({path: '/refundProduct/' + item.mainOrderId + '/' + item.commoditys[0].orderId + '/1/2'})
break;
case 4:  // 文创
this.$router.push('/refundIndex/' + item.mainOrderId + '/' + item.commoditys[index].orderId + '/4?index=' + item.commoditys[index].orderCdyId)
break;

default:
break;
}
},

confirmReceipt(item,index) {
const _this = this
const userInfo = JSON.parse(localStorage.getItem('userInfo'))
_this.confirmReceiptOK(userInfo,item,index)
},

confirmReceiptOK(info,item,index){
const _this = this
_this.$http.get('/api/wtcp-ecrm/order/goods/takeGoods?access_token=' + info.access_token + '&orderId=' + item.commoditys[0].orderId ).then(res => {
if (res.data.status==1) {
alert("已确认收货")
item.orderStatus = 4
item.orderStatusName = '已完成'
}
})
},

inRefundClick(item,index){
const _this = this
_this.$router.push('/refundDeal/' + item.mainOrderId + '/' +item.commoditys[0].orderId + '/' + item.orderType +'?index=' + item.commoditys[0].orderCdyId)
},
},
destroyed() {
window.removeEventListener('scroll', this.windowScroll)
}
}
